export default __webpack_public_path__ + "assets/flickr.bbc5502c.svg";